import { CardContainer } from "./CardContainer"
import { CardStat } from "./CardComps"
import LaunchIcon from "@mui/icons-material/Launch"
import { IconButton } from "@mui/material"
import { Link } from "react-router-dom"
import routes from "../../constants/routes"

const InventoryCard = ({ data }) => (
  <CardContainer
    disableEditDelete
    SummaryContent={
      <>
        <CardStat label="Name" value={data?.name} />
        <CardStat label="Status" value={data?.status} />
        <CardStat label="Type" value={data?.type} />
      </>
    }
    DetailsContent={
      <>
        <CardStat label="Model" value={data?.model} />
        <CardStat label="Serial Number" value={data?.serialNumber} />
      </>
    }
    ActionButtons={
      <Link to={`${routes.ADMIN.FACULTIES}/${data?.teacherUser}`}>
        <IconButton>
          <LaunchIcon />
        </IconButton>
      </Link>
    }
  />
)

export default InventoryCard
